module.exports = __webpack_public_path__ + "static/media/grand_mum_walk.73ffa81e.gif";